module.exports = __webpack_public_path__ + "web/img/logo.6975852c.png";